import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { HelpersService } from "../helpers-service/helpers.service";
import { isiFirmTaxDashboard } from "src/app/views-interfaces/dashboard-model.interface";
import { DashboardsService } from "../dashboards-service/dashboards.service";

export const cardAvailabilityGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const helpersService = inject(HelpersService);
    const dashboardsService = inject(DashboardsService);
    const router = inject(Router);
    const currentDashboard = await dashboardsService.getCurrentDashboard();
    if (isiFirmTaxDashboard(currentDashboard)) {
        await helpersService.initializeUserAvailableDocument();
        return helpersService.isCardAvailable(route.params.cardId) ? true : router.createUrlTree(["/card-view"]);
    } else return true;
};
